export default "__VITE_ASSET__BAWBidnK__"